import React from 'react';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { STATIC_ICONS } from '../../Constants';

const getTemplateImageUrl = (value) => {
    const normalized = String(value || '').trim().replace(/\\/g, '/');
    if (!normalized) return '';
    if (/^(?:blob:|data:|https?:\/\/)/i.test(normalized)) return normalized;
    return `${STATIC_ICONS}${normalized.replace(/^\/+/, '').replace(/^icons\//i, '')}`;
};

const TemplateImageEditor = ({
    label,
    image,
    onChange,
    onRemove,
    uploadText,
    helperText,
    disabled = false,
}) => {
    const imageUrl = getTemplateImageUrl(image);

    return (
        <div className="template-image-field">
            <div className="td-edit-label">{label || 'Template image'}</div>
            <div className={`template-image-editor${disabled ? ' is-disabled' : ''}`}>
                <label className="template-image-editor__picker">
                    <input
                        type="file"
                        accept="image/*"
                        onChange={onChange}
                        disabled={disabled}
                    />
                    {imageUrl ? (
                        <img
                            src={imageUrl}
                            alt=""
                            className="template-image-editor__preview"
                        />
                    ) : (
                        <div className="template-image-editor__empty">
                            <CloudUploadOutlinedIcon fontSize="large" />
                            <span>{uploadText || 'Upload image'}</span>
                        </div>
                    )}
                    <span className="template-image-editor__change">
                        {imageUrl ? (uploadText || 'Change image') : ''}
                    </span>
                </label>

                <div className="template-image-editor__meta">
                    <span>{helperText || 'PNG, JPG, WebP or SVG.'}</span>
                    {imageUrl && !disabled ? (
                        <button
                            type="button"
                            className="template-image-editor__remove"
                            onClick={onRemove}
                        >
                            <DeleteOutlineIcon fontSize="small" />
                            <span>Remove</span>
                        </button>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default TemplateImageEditor;
